// Fotos
(function () {
  "use strict";

  // Slide
  $(".anuncio-det-slide").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    autoplay: false,
    //autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".anuncio-det-slide-wrp").css("height", "auto");
  $(".anuncio-det-slide").css("opacity", "1");

  // LATERAL
  if (!isMobileX(1199) && $(".anuncio-lateral").length > 0) {
    const topSpacing = $(".header-full").outerHeight() + 20;
    const bottomSpacing = $(".section-rel").length > 0 ? 1300 : 453;
    $(".anuncio-lateral").sticky({
      topSpacing: topSpacing,
      bottomSpacing: bottomSpacing,
    });
  }

  // Exibe a âncora fixa (MOBILE)
  if (isMobileX(1199) && $("#reserva-mobile-sec").length > 0) {
    $(window).on(
      "scroll",
      debounce(function () {
        const offset =
          $("#reserva-mobile-sec").offset().top +
          $("#reserva-mobile-sec").outerHeight() -
          $(".header-full").outerHeight();
        if ($(window).scrollTop() > offset) {
          $(".anuncio-det-anchor").addClass("active");
        } else {
          $(".anuncio-det-anchor").removeClass("active");
        }
      }, 50)
    );
  }
})();
